<template>
  <div>
    <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
      <span>{{snackbar_message}}</span>
    </v-snackbar>     
    <v-row v-if="loading" class="pb-3 pt-3px-3">
        <v-col class="text-center">
          <v-progress-linear
            color="info"
            height="5"
            indeterminate
            striped
          ></v-progress-linear>
        </v-col>
    </v-row>
    <v-row v-else class="pl-4 pb-2 mt-1">
      <v-col cols="12" md="6" lg="3">
        <v-card class="neu-glow px-4 pb-4">
          <v-card-title>
            Coupon Recensioni
            <v-spacer></v-spacer>
            <v-div class="mr-n5">
              <!--
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" @click.stop="editItem()">
                    <v-icon color="info">mdi-plus-circle</v-icon>
                  </v-btn>
                </template>
                <span>Nuova</span>
              </v-tooltip>
              -->                  
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>                
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading" @click.stop="getData2()">
                    <v-icon color="info">mdi-sync-circle</v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>                                     
            </v-div> 
          </v-card-title>
          <v-card-text>
            <v-data-table
              class="neu-glow"
              fixed-header
              :headers="headers"
              :items="prizes||[]"
              hide-default-footer
              :items-per-page=500
              show-select
              :single-select=true
              :loading="loading||loading_refresh"
              no-data-text="Nessun dato presente in archivio"
              no-results-text="Nessun Risultato estratto"
              loading-text="Consultazione archivio: attendi..."
            >
              <template v-slot:[`item.remarks`]="{ item }">
                <v-tooltip top max-width="300">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="editItem(item)" icon v-bind="attrs" v-on="on" class="float-left">
                      <v-icon color="success">mdi-message-text</v-icon>
                    </v-btn>
                  </template>
                  <span v-html="item.remarks"></span>
                </v-tooltip>                        
              </template>

              <template v-slot:[`item.active`]="{ item }">
                <v-simple-checkbox
                  v-model="item.active"
                  color="info"
                  style="pointer-events: none"
                ></v-simple-checkbox>
              </template>

              <template v-slot:[`item.validity`]="{ item }">
                <div>{{item.validity}}</div>
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <!--
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs" 
                        v-on="on"
                        color="warning"
                        class="mr-2"
                        @click="editItem(item)"
                      >
                        mdi-pencil
                      </v-icon>                
                  </template>
                  <span>Modifica</span>
                </v-tooltip>
                -->
                
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs" 
                        v-on="on"
                        color="error"
                        class="mr-2"
                        @click="deleteItem(item)"
                      >
                        mdi-delete
                      </v-icon>                
                  </template>
                  <span>Elimina</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs" 
                        v-on="on"
                        color="info"
                        class="mr-2"
                        @click="showItem(item)"
                      >
                        mdi-eye
                      </v-icon>                
                  </template>
                  <span>Visualizza</span>
                </v-tooltip>

              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" lg="5" v-if="selectedItem">
        <v-card class="neu-glow px-4 pb-4">
          <v-card-title>
            Parametri <span class="info--text ml-2">{{selectedItem.prizeName}}</span>
            <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-4" :loading="loading_update" @click="saveItem()">
                    <v-icon color="info">mdi-creation</v-icon>
                  </v-btn>
                </template>
                <span>Crea Nuovo</span>
              </v-tooltip>  
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-4" :loading="loading_update" @click="saveItem()">
                    <v-icon color="info">mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>Salva Modifiche</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_instruction=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>              
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow" :loading="loading_update" @click="selectedItem=null">
                    <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Chiudi</span>
              </v-tooltip>               
          </v-card-title>
          <v-card-text>
           <v-row>
            <!--
            <v-col md="12">
              <v-text-field            
                counter
                label="Titolo Offerta"
                outlined
                v-model="selectedItem.title"
                hide-details
              >
              </v-text-field>              
            </v-col>
            <v-col md="12">
              <v-text-field            
                counter
                label="Descrizione"
                outlined
                v-model="selectedItem.description"
                hide-details
              >
              </v-text-field>                
            </v-col> -->
            <v-col md="6" class="d-flex justify-center">
              <div>Abilita Premio</div>
                <v-switch
                  color="info"
                  :label="selectedItem.prizeEnabled?'Abilitato':'Non Abilitato'"
                  dense
                  v-model="selectedItem.prizeEnabled"
                  inset
                  name="prizeEnabled"
                  hide-details
                  prepend-icon="mdi-trophy-variant"
                  class="pt-8 pt-0 mr-12"
                ></v-switch>              
            </v-col>
            <v-col md="6" class="text-center">
              <div class="pa-2">
                <div class="text-left pb-2">Giorni non validi per spendere il Premio</div>
                <v-btn-toggle v-model="selectedItem.excludedDoW" multiple small active-class="info">
                  <v-btn 
                    v-for="(d,di) in dows" :key="di" :value="di+1">
                    {{d.substring(0,2)}}
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-col>
            <v-col md="6">
              <div>Durata Premio (giorni)</div>
              <v-slider
                class="mt-12"
                color="info"
                max=31
                min=3
                step=1
                thumb-label="always"
                ticks="always"
                label=""
                hide-details
                v-model="selectedItem.duration"
              >        
              </v-slider>                               
            </v-col> 
            <v-col md="6">
              <div>Minimo per Google/TA</div>
              <v-slider
                class="mt-12"
                color="info"
                max=15
                min=6
                step=1
                thumb-label="always"
                ticks="always"
                label=""
                hide-details
                v-model="selectedItem.externalReviewThreshold"
              >        
              </v-slider>              
            </v-col>                          
            <v-col md="6">
              <div>Intervallo Premio 1</div>
              <v-range-slider
                class="mt-12"
                color="info"
                max=15
                min=1
                step=1
                thumb-label="always"
                ticks="always"
                label=""
                hide-details
                v-model="selectedItem.highRewardRange"
              >        
              </v-range-slider>              
            </v-col> 
            <v-col md="6">
              <div>Intervallo Premio 2</div>
              <v-range-slider
                class="mt-12"
                color="info"
                max=15
                min=1
                step=1
                thumb-label="always"
                ticks="always"
                label=""
                hide-details
                v-model="selectedItem.lowRewardRange"
              >        
              </v-range-slider>                 
            </v-col> 
            <v-col md="6">
              <v-text-field            
                counter
                label="Nome 1° Premio"
                outlined
                v-model="selectedItem.highRewardName"
                hide-details
              >
              </v-text-field>             
            </v-col> 
            <v-col md="6">
              <v-text-field            
                counter
                label="Nome 2° Premio"
                outlined
                v-model="selectedItem.lowRewardName"
                hide-details
              >
              </v-text-field>                  
            </v-col>
            <v-col md="6">
              <div class="mb-2">Immagine Premio 1</div>
              <v-img v-if="selectedItem.highRewardImage" 
                :src="'/static/users/pictures/coupons/'+selectedItem.highRewardImage||'/static/users/pictures/coupons/default.png'"
                :lazy-src="'/static/users/pictures/coupons/'+selectedItem.highRewardImage||'/static/users/pictures/coupons/default.png'"
                max-width="200"
                class="mx-auto"
              ></v-img>              
            </v-col> 
            <v-col md="6">
              <div class="mb-2">Immagine Premio 2</div>
              <v-img v-if="selectedItem.lowRewardImage" 
                :src="'/static/users/pictures/coupons/'+selectedItem.lowRewardImage||'/static/users/pictures/coupons/default.png'"
                :lazy-src="'/static/users/pictures/coupons/'+selectedItem.lowRewardImage||'/static/users/pictures/coupons/default.png'"
                max-width="200"
                class="mx-auto"
              ></v-img>              
            </v-col>             
            <!--
            <v-col md="6">
              <v-date-picker
                v-model="editedItem.dateRange"
                range
              ></v-date-picker>                
            </v-col> -->                                                                                                            
           </v-row>
          </v-card-text>
        </v-card>          
      </v-col>      
      <v-col cols="12" md="6" lg="2" v-if="selectedItem">
        <v-card class="neu-glow px-2 pb-4">
          <v-card-title>
            Recensione del Cliente
            <v-spacer></v-spacer>
              <!--
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" @click="selectedItem=null">
                    <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Close</span>
              </v-tooltip>
              -->               
          </v-card-title>
          <v-card-text>
            <v-card  class="px-2 py-2 neu-glow">
              <template v-for="(v,n,i) in review">
                <template v-if="n!='review'">
                  <v-divider v-if="i!=0" :key="i"></v-divider>
                  <v-row :key="i" class="mt-2">
                    <v-col class="text-h6 d-flex align-center ml-2 py-0">{{$t('Review.'+n)}}</v-col>
                    <v-col class="pt-0">
                        <v-rating
                          v-model="review[n]"
                          background-color="#ffcb8c"
                          color="#d77700"
                          size="20"
                          hover                     
                          ></v-rating>
                    </v-col>
                  </v-row>
                </template>
              </template>
            </v-card> 
          </v-card-text>
        </v-card>          
      </v-col>
      <v-col cols="12" md="6" lg="2" v-if="selectedItem">
        <v-card class="neu-glow px-4 pb-4">
          <v-card-title>
            Cosa vede il Cliente
            <v-spacer></v-spacer>
            <!--
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" @click="selectedItem=null">
                    <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Close</span>
              </v-tooltip>
              -->               
          </v-card-title>
          <v-card-text>
            <v-card class="pa-4  neu-glow">
              <div>
                {{$t('Review.Thanks for your time')}},
                <p>{{$t('Review.Your opinion is very important to us since it help us every day to improve')}}</p>
                <p v-if="!selectedItem.hasPrize||!selectedItem.prizeEnabled" class="text-center pt-5"><v-icon color="red" style="font-size:140px">mdi-heart</v-icon></p>
                <template v-else> 
                  <p>{{$t('Review.We are happy to inform that we have reserved you a free coupon to be used within')}}
                    <span class="font-weight-bold text-center">
                      {{' ' + addDaysFormatted(selectedItem.duration)}}
                    </span>
                    <span v-if="selectedItem.excludedDoW">, ({{dows.filter((d,i)=>selectedItem.excludedDoW.includes(i+1)).join(', ')}} {{$t('Review.excluded')}} ), </span>
                    {{$t('Review.for')}}
                  </p>
                  <p class="text-center font-weight-bold">{{selectedItem.reviewPrize}}</p>
                  <v-img v-if="selectedItem.reviewImage" 
                    :src="'/static/users/pictures/coupons/'+selectedItem.reviewImage||'/static/users/pictures/coupon/default.png'"
                    :lazy-src="'/static/users/pictures/coupons/'+selectedItem.reviewImage||'/static/users/pictures/coupon/default.png'"
                    max-width="200"
                    class="mx-auto"
                  ></v-img>
                  <p>{{$t('Review.At your arrival, remember to show the QRCode to the waiter')}}</p>
                  <div class="text-center">
                    <qrcode-vue :value="QRCodeLink" :size="50" level="L"></qrcode-vue>
                  </div>
                  <p class="text-center">{{$t('Review.For your convenience, we just sent you a WhatsApp message with the QR Code')}}</p>
                </template>
              </div>
            </v-card>            
          </v-card-text>
          <v-card-text v-if="sumReviews>=selectedItem.externalReviewThreshold">
            <v-card class="pa-4  neu-glow">
              <div>
                {{$t('Review.Thanks for your time')}}, 
                <p>{{$t('Review.Share your review loading it on Tripadvisor and or Google')}}:</p>
                <p>{{$t('Review.Your review has already been copied into the clipboard: you have just to paste it')}}</p>
                <p>{{$t('Review.To proceed, click the button')}}.</p>
              </div>
              <v-btn color="#00aa6c" block >
                Tripadvisor
              </v-btn>
              <v-btn class="mt-2" color="info" block >
                Google
              </v-btn> 
            </v-card>
          </v-card-text>
        </v-card>          
      </v-col>
    </v-row>
    <v-dialog v-model="dialog_edit" max-width="1200" class="pb-3" v-if="editedItem">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              {{editedItem.value?'Modifica Premio':'Crea Premio'}}
              <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <div>
                    <v-btn v-bind="attrs" v-on="on" fab icon small class="neu-glow mr-3" :disabled="hash==JSON.stringify(editedItem)" :loading="loading_update" @click="saveItem('save')">
                      <v-icon color="error">mdi-content-save</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span>Salva</span>
              </v-tooltip>
              <v-tooltip top >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="dialog_edit=false" fab small class="neu-glow" :disabled="hash!=JSON.stringify(editedItem)"  v-bind="attrs" v-on="on">
                    <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Chiudi</span>
              </v-tooltip>               
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5 mt-1 mb-0 pb-3">
              <v-col cols="12">
                  <v-text-field            
                    counter
                    label="Nome"
                    outlined
                    v-model="editedItem.text"
                    persistent-placeholder
                    hide-details
                    :loading="loading_refresh"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-select           
                    counter
                    label="Area"
                    outlined
                    :items="allLocationsTable"
                    v-model="editedItem.locationId"
                    persistent-placeholder
                    hide-details
                    :loading="loading_refresh"
                  >
                  </v-select>
                </v-col>
                <v-col cols="6" v-show="editedItem.value" class="d-flex justify-center mt-n3">
                <v-switch
                    v-model="editedItem.active"
                    inset
                    :label="editedItem.active?'Attiva':'Non Attiva'"
                ></v-switch>
                </v-col>                                               
                <v-col cols="6">
                  <v-text-field
                    label="Ordinamento"
                    outlined
                    reverse
                    type="number"
                    v-model="editedItem.sortOrder"
                    persistent-placeholder
                    hide-details
                    :loading="loading_refresh"
                  >
                  </v-text-field> 
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    label="Colonne"
                    outlined
                    reverse
                    type="number"
                    v-model="editedItem.cols"
                    persistent-placeholder
                    hide-details
                    :loading="loading_refresh"
                  >
                  </v-text-field> 
                </v-col>                                                                
            </v-row>
        </v-card>
    </v-dialog>  
    <v-dialog v-model="dialog_instruction" max-width="800">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              Istruzioni
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction = false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>Esci</span>
              </v-tooltip> 
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5 mt-1">
                <v-col md="6" cols="12">
                    <p>
                        Per ogni <strong>Slot</strong> di <strong>Ogni Giorno</strong>, di ogni <strong>Turno</strong> e per ogni <strong>Area</strong>, è possibile impostare vari parametri:
                        <ul>
                          <li>
                            Il numero massimo di Coperti prenotabili direttamente dal Cliente
                          </li>
                          <li>
                            Il numero massimo di tavoli da 1, 2 e 3 Coperti prenotabili direttamente dal Cliente
                          </li>
                          <li>
                            La durata dello slot, ovvero per quanto tempo il cliente può impegnare il tavolo
                          </li>
                          <li>
                            La somma richiesta, per ogni coperto, per accettare la prenotazione - ad esempio capodanno - (richiede account PayPal)
                          </li>
                          <li>
                            L'orario dal quale non vengno più accettate prenotazioni per il giorno stesso, ma il sistema invita a chiamare il locale e parlare con lo staff
                          </li>
                          <li>Se inviare o meno la richiesta di rilascio Feedback</li>
                        </ul>
                    </p>
                </v-col>
                <v-col md="6" cols="12">
                  <p>
                    Per velocizzare le operazioni di inserimento, 
                  </p>
                  <p>
                    Il pulsante 'Salva' si attiva qualora rilevi differenze rispetto ai dati memorizzati.
                  </p>
                  <p>
                    Dopo il salvataggio i dati vengono automaticamente ricaricati: qualora notaste delle incongruenze, prima di fare ulteriori modifiche cliccare sul tasto 'Refresh'
                  </p>
                </v-col>
                <v-col cols="12">
                  <p color="error--text">
                    <strong>Nota:</strong> Questi vincoli valgono solo per le prenotazioni dirette da parte dei clienti. L'operatore può accettare qualsiasi prenotazione e bypassare ogni blocco.
                  </p>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
//import _ from 'lodash'
import QrcodeVue from 'qrcode.vue'
export default {
   components: {
      QrcodeVue,
    },  
  data() {
    return {
      page: "Settings",
      loading:false,
      loading_update:false,
      dialog_instruction:false,
      dialog_edit:false,
      dialog_delete:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      snackbar:null,
      snackbar_color:null,
      snackbar_message:null,
      allLocations:null,
      clockStep:null,
      activeSlots:null,
      activeSlots_hash:null,
      tabs:[],
      mealId:null,
      tabId:null,
      dowId:null,
      slotId:null,
      review:{"food":5,"service":5,"value":5,"location":5,"review":null},
      editedItem:{text:"",value:null,sortOrder:null,icon:"",active:false},
      emptyItem:{text:"",value:null,sortOrder:null,icon:"",active:false},
      dows:['LUN','MAR','MER','GIO','VEN','SAB','DOM'],
      headersPromo:[
              {title:"Omaggio",remarks:"Omaggio (per persona) offerto"},
              ],
      headers: [
                //{ text: 'Attiva',       value: 'active',      align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                { text: 'Nome',         value: 'prizeName',   align: 'start',   sortable: false, class:'px-1 text-lg-button' },
                //{ text: 'dal/al',       value: 'validity',    align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                //{ text: 'Esigibilità',  value: 'duration',    align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                //{ text: 'Esclusi',      value: 'excludedDoW', align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                { text: 'Azione',       value: 'actions',     align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
              ],              
      allMeals:null,
      selectedItem:null,
      sumReviews:null
    };
  },
  computed : {
    ...mapGetters(["settings"]),
  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){
    this.getData()
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    'selectedItem.highRewardRange':function (newVal,oldVal){
      console.log(559,newVal,oldVal,this.review)
      this.calcPrize()
    },
    'selectedItem.lowRewardRange':function (newVal,oldVal){
      console.log(559,newVal,oldVal,this.review)
      this.calcPrize()
    },
    'review.food':function (newVal,oldVal){
      console.log(559,newVal,oldVal,this.review)
      this.calcPrize()
    },
    'review.service':function (newVal,oldVal){
      console.log(559,newVal,oldVal,this.review)
      this.calcPrize()
    },
    'review.value':function (newVal,oldVal){
      console.log(559,newVal,oldVal,this.review)
      this.calcPrize()
    },    
    item (newValue) {
      console.log(289,newValue)
      //this.getData(newValue)
    }
  },
  methods:
  {
   addDaysFormatted(days) {
     var result = new Date();
     result.setDate(result.getDate() + days);
     return result.toLocaleDateString('it-IT',{ weekday: 'long',  month: 'long', day: 'numeric' });
   },
   calcPrize()
   {
      const review2={...this.review};
      delete review2.location;
      const sumReviews = Object.values(review2).reduce((a, b) => a + b, 0);
      this.sumReviews=sumReviews;
      const hrr=this.selectedItem.highRewardRange;
      const lrr=this.selectedItem.lowRewardRange;
      console.log(653,hrr,lrr,sumReviews)
      if(sumReviews>=hrr[0]&&sumReviews<=hrr[1])
      {
        console.log(656)
        this.selectedItem.hasPrize=true
        this.selectedItem.reviewPrize=this.selectedItem.highRewardName;
        this.selectedItem.reviewDescription=this.selectedItem.highRewardDescription;
        this.selectedItem.reviewImage=this.selectedItem.highRewardImage;
      }
      else if (sumReviews>=lrr[0]&&sumReviews<=lrr[1])
      {
        console.log(663)
        this.selectedItem.hasPrize=true
        this.selectedItem.reviewPrize=this.selectedItem.lowRewardName;
        this.selectedItem.reviewDescription=this.selectedItem.lowRewardDescription;
        this.selectedItem.reviewImage=this.selectedItem.lowRewardImage;
      }
      else
      {
        console.log(670)
        this.selectedItem.hasPrize=false
        this.selectedItem.reviewPrize=null;
        this.selectedItem.reviewDescription=null;
        this.selectedItem.reviewImage=null;
      }
   },
   save: _.debounce(function (event) {
      //this.refreshItem(event.target.name,event.target.value)
      console.log(296,event);
      console.log(297,event.target.name,event.target.value,event.target.id)
      console.log(298,this.dowId,this.mealId,this.activeSlots)
      //console.log(299,this.VMOptions[event.target.name])

      var v=event.target.value
      var value=v===false?0:v===true?1:v===''?null:v
      var dow=this.dows.findIndex(d=>d==this.dowId)+1
      var pload={"parameter":event.target.name,"value":value,"slotId":event.target.id,"dow":dow};
      //var pload={[event.target.name]:event.target.value};
      var action='saveItem';
      let payload={"action":action,"table":"AllParametersByDOW_single","payload":pload};
      console.log(307,payload)
      this.updateDB(payload)
    }, 1000), 
    showItem(i)
    {
      this.selectedItem=i;
    },  
    editItem(f=null)
    {
      if (f) 
      {
        this.editedItem=f;
      }
      else{
        this.editedItem={...this.emptyItem};
        this.editedItem.active=1;
      }
      console.log(214,f)
      this.hash=JSON.stringify(this.editedItem);
      this.dialog_edit=true;
    },
    deleteItem(f)
    {
      this.editedItem=f;
      console.log(214,f)
      this.dialog_delete=true;
    },    
    async saveItem(a)
    {
        console.log(144,this.editedItem);
        this.loading_update=true;
        console.log(255,this.form);
        var action='';
        if(a=='delete')
        {
          action='deleteItem'
          this.editedItem.erase=1;
        }
        else
        {
          action='saveItem';
        }
        let payload={"action":action,"table":"Locations","payload":JSON.stringify(this.editedItem)};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.payloads.message;
            this.snackbar = true;
            this.dialog_edit=false;
            this.dialog_delete=false;
            this.$root.$emit('onupdateLocations', null);
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }   
        this.editedItem={...this.emptyItem}
    },
    async getData(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            try{
                const payload=JSON.stringify({"action":"AllPrizes_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading_refresh=false;
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.prizes=res.data.payloads.allPrizes;

                    console.log(315,this.prizes)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },    
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(383,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;
            
            if (res.data.message)
            {
                console.log(392);
                this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(401);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    }
  },
};
</script>